import React from 'react'
import PageHeader from '../../components/PageHeader'
import { Box } from '@mui/material'
import CourseAttributes from './CourseAttributes'

const AttributesFeature: React.FC = (): JSX.Element => {
  return (
    <Box display='flex' flexDirection='column' gap={6}>
      <PageHeader title='Attributes' showBackButton />
      <CourseAttributes/>
    </Box>
  )
}

export default AttributesFeature
